export const currencyFormat = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});

export function formatCurrencyCents(centsValue?: number) {
    if(centsValue == null) return '';
    return formatCurrency(centsValue / 100.0);
}

export function formatCurrency(amount?: number) {
    if(amount == null) return '';
    return currencyFormat.format(amount);
}

export function formatPickSource(s: string) {
    if(s == 'pick') {
        return 'Dashboard';
    }
    else if (s == 'namecheapEvent') {
        return 'Namecheap Stream';
    }
    else {
        return s;
    }
}

export function formatPickStatus(s: string) {
    if(s == 'pending') {
        return 'Eligible to Pick';
    }
    else if(s == 'upstreamPicked') {
        return 'Auto Picked (Legacy)';
    }
    else if(s == 'userRenew') {
        return'User Renew';
    }
    else if(s == 'autoPicked') {
        return 'Auto Picked (New)';
    }
    else {
        return s;
    }
}
